import { render, staticRenderFns } from "./ProfileForReviewForm.vue?vue&type=template&id=7101b060&scoped=true&"
import script from "./ProfileForReviewForm.vue?vue&type=script&lang=js&"
export * from "./ProfileForReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileForReviewForm.vue?vue&type=style&index=0&id=7101b060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7101b060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextField,VTextarea})
